/** Experience levels — aligned with job listings filters */
export const JOB_LISTING_EXPERIENCE_OPTIONS = [
  'Fresher',
  '0-1 years',
  '1 Year',
  '2 Years',
  '3 Years',
  '4 Years',
  '5 Years',
  '5-7 Years',
  '10+ years',
];

/** Job sources — aligned with job listings filters */
export const JOB_LISTING_SOURCE_OPTIONS = [
  'Linkedin',
  'Indeed India',
  'Glassdoor India',
  'Company',
  'Govt',
  'Naukri',
];

export const JOB_LISTING_JOB_TYPE_OPTIONS = [
  'Full-time',
  'Part-time',
  'Contract',
  'Internship',
  'Temporary',
];

export const JOB_LISTING_JOB_MODE_OPTIONS = ['Remote', 'On-site', 'Hybrid'];
